import postServices from '../../services/post';
import Post from '../../model/post';

export const state = {
    posts: [],
    post: {},
}

export const mutations = {
    setPost(state, post) {
        state.post = post
    },
    setPosts(state, posts) {
        state.posts = posts
    },
    addPost(state, post) {
        state.posts = [post, ...state.posts]
    },
}

export const getters = {
    getPost(state) {
        return new Post(state.post);
    },
    getPosts(state) {
        let posts = state.posts
        return posts.map((p)=>{return new Post(p)})
    },
}

export const actions = {
    get({commit}, id){
        return postServices.get(id)
        .then((response)=>{
            commit('setPost', response.data.data)
            return response
        })
    },
    getAll({commit}, data = {}){
        return postServices.getAll(data)
        .then((response)=>{
            commit('setPosts', response.data.data)
            return response
        })
    },
    add({commit}, post){
        return postServices.add(post)
        .then((response)=>{
            commit('addPost', response.data.data)
            return response
        })
    },
    edit({commit, state}, {id, post}){
        return postServices.edit(id, post)
        .then((response)=>{
            let posts = state.posts
            posts[posts.findIndex((x)=>x.id == id)] = response.data
            commit('setPosts', posts)
            return response
        })
    },
    delete({commit}, id){
        return postServices.delete(id)
        .then((response)=>{
            commit('setPosts', state.posts.filter((x)=>x.id != id))
            return response
        })
    },
}